import api from "../Service/Api";
import { toastr } from "react-redux-toastr";

const successStoryController = "api/success-story";

export const createSuccessStoryApi = async (body) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(
        `${successStoryController}/create-SuccessStory`,
        body
      );
      toastr.success(`Added Success Story Successfully!`);
      return response.data.data;
    }
  } catch (error) {
    toastr.error(error.response.data.title, error.response.data.message);
    throw error;
  }
};

export const getAllSuccessStoryApi = async (params) => {
  try {
    if (navigator.onLine) {
      const response = await api.get(
        `${successStoryController}/get-all-SuccessStories`,
        { params }
      );
      return response.data;
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message);
    throw error;
  }
};

export const getSuccessStoryByIdApi = async (id) => {
  try {
    if (navigator.onLine) {
      const response = await api.get(
        `${successStoryController}/get-SuccessStory-by-id/${id}`
      );
      return response.data.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateSuccessStoryApi = async (payload) => {
  try {
    if (navigator.onLine) {
      const response = await api.put(
        `${successStoryController}/edit-SuccessStory/${payload.id}`,
        payload.body
      );
      toastr.success(`Edits successfully saved`);
      return response.data.data;
    }
  } catch (error) {
    toastr.error(
      `We encountered an error saving your details`,
      `Please try again shortly`
    );
    throw error;
  }
};

export const approveSuccessStoryApi = async (payload) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(
        `${successStoryController}/approve-SuccessStory`,
        payload
      );
      toastr.success(`Processed Successfully`);
      return response.data.data;
    }
  } catch (error) {
    toastr.error(
      `We encountered an error saving your details`,
      `Please try again shortly`
    );
    throw error;
  }
};

export const getSuccessStoryWithoutPaginationApi = async () => {
  try {
    if (navigator.onLine) {
      const response = await api.get(
        `${successStoryController}/get-all-SuccessStories-no-pagination`
      );
      return response.data;
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message);
    throw error;
  }
};

export const getTotalSuccessStoryApi = async () => {
  try {
    if (navigator.onLine) {
      const response = await api.get(
        `${successStoryController}/get-total-SuccessStories-details`
      );
      return response.data;
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message);
    throw error;
  }
};
